import { EditManualBankAccountModalState } from '../enums/editManualBankAccountModalState'

export interface EditManualBankAccountModalStateConfig {
  subHeaderTKey?: string
  saveButtonTKey: string
}

export const EditManualBankAccountModalStates: Record<
  EditManualBankAccountModalState,
  EditManualBankAccountModalStateConfig
> = {
  [EditManualBankAccountModalState.Edit]: {
    saveButtonTKey: 'save',
  },
  [EditManualBankAccountModalState.CreateForCsvImport]: {
    subHeaderTKey: 'bank.account.modal.subheader.import_csv',
    saveButtonTKey: 'next',
  },
}
